window.dtCandidate = function () {
  const dt_candidate = new DataTable('#candidate-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#candidate-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#candidate-datatable', 5); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "first_name" },
      { "data": "last_name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(3)', row).html(`${data.first_name} ${data.last_name}`);
      $('td:eq(3)', row).attr('colspan', 2);
      $('td:eq(4)', row).remove()
    },
  });

  dtFinalTouch()
}

 